import { APP_EMITTER_EVENTS, AppEmitter } from "shared";

export const scrollToErrorFields = () => {
    setTimeout(() => {
        const errorComponents = document.querySelectorAll(".Textinput_state_error .Textinput-Hint");
        if (errorComponents.length > 0) {
            AppEmitter.emit(APP_EMITTER_EVENTS.blockLayoutScroll);
            setTimeout(() => {
                errorComponents[0].scrollIntoView({ behavior: "smooth", block: "center" });
            }, 100);
        }
    });
}
